import { DateTime } from 'luxon'
import { statusDefaultIcon, statusDefaultTextColor } from '../trasmissione-reportnet.config';

export const PRELIEVO_STATUS = ['ok', 'warning', 'alert'] as const;
export type TPrelievoStatus = typeof PRELIEVO_STATUS[number];

export interface IPrelievo{
  id?: number,
  idControlli: [],
  codicePrelievo: string,
  dataPrelievo: Date,
  oraPrelievo: string,
  prelievoOperatoDa: string,
  codiceAnalisi: string,
  dataAnalisi: Date,
  oraAnalisi: string,
  analisiOperateDa: string,
  tipoControllo?: string,
  poiId: number,
  codicePoi: string,
  processoId?: number,
  status: TPrelievoStatus,//'ALERT' | 'WARNING' | 'OK',
  createdBy?: string,
  createdDate?: DateTime,
  uuid:string,
  dataOraPrelievo:string
}

export function getStatusIcon(status: TPrelievoStatus): string {
  let icon = statusDefaultIcon[status];
  let textColor = statusDefaultTextColor[status];
  return `<mat-icon matTooltip="${status}" class="mat-mdc-tooltip-trigger ${textColor} material-symbols-outlined">${icon}</mat-icon>`;
}

export function getParametriDatiPrelievoFk(dati: any): string | undefined {
  let ris = '';
  if (dati.length > 1) {
    for (let i=0; i<dati.length; i++) {
      ris = ris + dati[i].parametro + '<br>';
    }
    return ris;
  } else if (dati.length == 1) {
    ris += dati[0].parametro;
    return ris;
  } else {
    return;
  }
}

export function getDefDatiPrelievoFk(dati: any): string | undefined {
  let ris = '';
  if (dati.length > 1) {
    for (let i=0; i<dati.length; i++) {
      ris = ris + dati[i].definizione + '<br>';
    }
    return ris;
  } else if (dati.length == 1) {
    ris += dati[0].definizione;
    return ris;
  } else {
    return;
  }
}

export function getValDatiPrelievoFk(dati: any): string | undefined {
  let ris = '';
  if (dati.length > 1) {
    for (let i=0; i<dati.length; i++) {
      ris = ris + dati[i].valore + '<br>';
    }
    return ris;
  } else if (dati.length == 1) {
    ris += dati[0].valore;
    return ris;
  } else {
    return;
  }
}

export function getSiNo(boolparam: boolean): string {
  if (boolparam) {
    return 'si'
  } else {
    return 'no'
  }
}

export function getDescrAzioneCorrettiva(dati: any): string | undefined {
  let ris = '';
  if (dati.length > 1) {
    for (let i=0; i<dati.length; i++) {
      ris = ris + dati[i].descrizione + '<br>';
    }
    return ris;
  } else if (dati.length == 1) {
    ris += dati[0].descrizione;
    return ris;
  } else {
    return;
  }
}

export function getStatiPrelievoFk(dati: any): string | undefined {
  let ris = '';
  if (dati.length > 1) {
    for (let i=0; i<dati.length; i++) {
      ris = ris + getStatusIcon(dati[i].status) + '<br>';
    }
    return ris;
  } else if (dati.length == 1) {
    ris += getStatusIcon(dati[0].status);
    return ris;
  } else {
    return;
  }
}